module.exports = __webpack_public_path__ + "media/images/icons/datatable/sort_desc-45d1f75c039557dd6c7d2180cf639397.png";